import { tagCommanderConfig } from '../../../config/tagCommanderConfig';
import { SupportedLocale } from '../../../services/locale';

const { scriptsForLocales } = tagCommanderConfig;

export const getScriptForLocale = (country: string, language: string) => {
  const key = `${language}-${country}`;
  return scriptsForLocales[key]
    ? scriptsForLocales[key]
    : scriptsForLocales[SupportedLocale.default];
};
